module.exports = __webpack_public_path__ + "static/media/navbar_search_button.5b888d1e.svg";